import { createContext, useState } from "react";

export const SelectedDataSet = createContext();
export const SelectedDataSetProvider = ({ children }) => {
  const [selectedIdx, setSelectedIdx] = useState();
  const [selectedDataSet, setSelectedDataSet] = useState();
  const [selectedDatasetName, setSelectedDatasetName] = useState();
  const getSelectedIdx = (data) => {
    setSelectedIdx(data);
  };
  const getSelectedDataSet = (data) => {
    setSelectedDataSet(data);
  };
  const getSelectedDatasetName = (data) => {
    setSelectedDatasetName(data);
  };
  // console.log(selectedDataSet);
  return (
    <SelectedDataSet.Provider
      value={{
        selectedIdx,
        getSelectedIdx,
        getSelectedDataSet,
        selectedDataSet,
        getSelectedDatasetName,
        selectedDatasetName,
      }}>
      {children}
    </SelectedDataSet.Provider>
  );
};
